import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const CHAVE_CONSENTIMENTO = 'manux_cookie_consent';

export default function CookieConsent() {
  const [visivel, setVisivel] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(CHAVE_CONSENTIMENTO)) return;
    setVisivel(true);
  }, []);

  async function aceitar() {
    localStorage.setItem(CHAVE_CONSENTIMENTO, 'aceito');
    setVisivel(false);
    try {
      await fetch('/api/cookie-consent.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          pagina: window.location.href,
          referrer: document.referrer,
          idioma: navigator.language,
          resolucao: `${window.screen.width}x${window.screen.height}`,
          fuso: Intl.DateTimeFormat().resolvedOptions().timeZone,
        }),
      });
    } catch {
      // aviso de cookies nao deve travar por causa de uma falha de rede
    }
  }

  function recusar() {
    localStorage.setItem(CHAVE_CONSENTIMENTO, 'recusado');
    setVisivel(false);
  }

  if (!visivel) return null;

  return (
    <div className="cookie-consent" role="dialog" aria-live="polite">
      <p>
        Usamos cookies para melhorar sua experiência e entender como o site é usado.
        Ao continuar navegando, você concorda com nossa{' '}
        <Link to="/privacidade">Política de Privacidade</Link>.
      </p>
      <div className="cookie-consent-acoes">
        <button type="button" className="lp-link" onClick={recusar}>Recusar</button>
        <button type="button" className="btn sm" onClick={aceitar}>Aceitar</button>
      </div>
    </div>
  );
}
